import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";


export const getFaqById = async (id) => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}faq/faq/?id=${id}`);
    return response.data?.data || null;
  } catch (error) {
    throw error;
  }
};

export const getFaqs = async (params) => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}faq/faq`, { params });
    if (response.data.response_code === 1) {
      return response.data.data;
    } else {
      return [];
    }
  } catch (error) {
    throw error;
  }
};


export const addFaq = async (formValues) => {
  try {
    const response = await authenticatedAxios.post(`${baseurl}faq/faq/`, formValues);
    if (response.data.response_code === 1) {
      return response.data;
    } else {
      throw new Error(response.data.message || "Something went wrong!");
    }
  } catch (error) {
    throw new Error(error.message || "Failed to add FAQ");
  }
};

export const editFaq = async (id, formValues) => {
  try {
    const response = await authenticatedAxios.put(`${baseurl}faq/faq/?id=${id}`, formValues);
    if (response.data.response_code === 1) {
      return response.data;
    } else {
      throw new Error(response.data.message || "Something went wrong!");
    }
  } catch (error) {
    throw new Error(error.message || "Failed to update FAQ");
  }
};

// Archive a single FAQ
export const archiveFaq = async (id) => {
  const response = await authenticatedAxios.get(`${baseurl}faq/faq/archive/?id=${id}`);
  if (response.status < 200 || response.status >= 300) {
    throw new Error("Failed to archive FAQ");
  }
  return response.data;
};

// Archive multiple FAQs
export const archiveFaqBulk = async (idList) => {
  const response = await authenticatedAxios.post(`${baseurl}faq/faq/archive/`, {
    id_list: idList,
  });
  if (response.status < 200 || response.status >= 300) {
    throw new Error("Failed to archive selected FAQs");
  }
  return response.data;
};

// Delete FAQ
export const deleteFaq = async (id) => {
  const response = await authenticatedAxios.delete(`${baseurl}faq/faq/?id=${id}`);
  if (response.status < 200 || response.status >= 300) {
    throw new Error("Failed to delete FAQ");
  }
  return response.data;
};

